export enum FilterItemKeys {
  NAME = "name",
}

export const FILTER_ITEMS_DICTIONARY: Partial<Record<FilterItemKeys, string>> = {
  [FilterItemKeys.NAME]: "name",
};

export const LOADING_THRESHOLD = 18;
